/* eslint-disable no-underscore-dangle */
import React from "react";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

const PH_PREFIX = {
  ORG: "org::",
  EVENT: "event::",
  USER: "user::"
};

function ConfigureAnalytics({ children, user, orgDetails, eventDetails }) {
  const posthog = usePostHog();
  const userId = `${PH_PREFIX.USER}${window.__ENV__}::${user.id}`;
  const orgId = eventDetails.org_id || orgDetails.id;
  const currentOrgId = orgId ? `${PH_PREFIX.ORG}${orgId}` : null;
  const currentEventId = eventDetails?.id
    ? `${PH_PREFIX.EVENT}${eventDetails.id}`
    : null;

  useEffect(() => {
    if (window.Appcues) {
      window.Appcues.identify(userId, {
        env: window.__ENV__,
        email: user.email,
        first_name: user.fname,
        last_name: user.lname,
        name: user.displayName,
        current_org_id: currentOrgId,
        current_event_id: currentEventId
      });

      if (currentOrgId) {
        let companyProperties = {};
        if (orgDetails?.name) {
          companyProperties = {
            name: orgDetails.name
          };
        }
        window.Appcues.group(
          currentOrgId, // unique, required
          {
            ...companyProperties
            // example custom group properties
            // createdAt: 1566932390, // Unix timestamp of account signup date
            // purchasedAt: 1566932395, // Unix timestamp of account purchase date
            // planTier: "Standard", // Account's plan tier
            // companyName: "CoolCo", // Account's name
            // MRR: 599, // Account's monthly recurring revenue
            // renewalDate: "06202035" // Timestamp of upcoming account renewal date
            // accountmanager: "Jerry" // Account manager
          }
        );
      }
    }

    if (posthog && user) {
      // Identify sends an event, so you want may want to limit how often you call it
      posthog.identify(userId, {
        email: user.email,
        current_org_id: currentOrgId,
        current_event_id: currentEventId
      });

      if (currentOrgId) {
        let companyProperties;
        if (orgDetails?.name) {
          companyProperties = {
            name: orgDetails.name
          };
        }
        posthog.group("company", currentOrgId, companyProperties);
      }
    }
  }, [posthog, user.id, user.email, currentOrgId, currentEventId]);

  return <>{children}</>;
}

export default ConfigureAnalytics;
